<script>

import Qrimage from './Qrimage.svelte';
import Propval from './Propval.svelte';
import NearbyMerchants from './NearbyMerchants.svelte';
import ProductDesc from './ProductDesc.svelte';
import ContactSupport from './ContactSupport.svelte';
import Spinner from './Spinner.svelte';
import Toast from './Toast.svelte';


// import { fade } from 'svelte/transition';
// import { fly } from 'svelte/transition';
import { slide } from 'svelte/transition';


// let webUrl = window.location.href;
// let tokenId = webUrl.split('/')[3];


export let tokenId;


let TOKEN_API_HOST='';

if (TOKEN_ENV === 'development') {
	TOKEN_API_HOST = "http://localhost:7000";
}

let products = [];

let qrImage = '';
let qrString = '';
let current_amount = '';
let old_amount = '';
let expiry_date = '';
let customerName = '';
let customerMobile = '';
let brand_name = '';
let brand_logo = '';
let tokenDetailErr = '', tokenDetailReason = '';
let paymentStatusDesc = '';

let nearbymerchant = [];
let saleDesc = '';
let showNearbyMerchantsSection = false;
let showProductDescSection = false;
let nearbyMerchantsErr = '';
const nearbyMerchantsErrMsg = 'Some error has occurred in fetching nearby EkoStores. Kindly check your internet connection';
const toastTimeout = 5000;

let tokenStatus = '-1'; // Initial value - no data

let QRErr = '';

let brandCSEmail = '';
let brandCSLink = '';
let nearbyMerchantsLoading = false;

let isMobileDevice = false;
// let txstatusDesc = '';

let priceChanged = false;


let QRapiCall = true;
// let showNearbyMarchanrsBtn = true;
// let showProductDescBtn = true;

// let lat = '', long = '';

let showHowSection = false;

let waitingForLocation = false;

const invalidIdMsg = 'Invalid Token. Please check Token ID';

let _fetchingTokenStatus = false;

const TOKEN_LENGTH = 16;


let showStatusToast = false;
function getTokenDetails() {

	QRapiCall = true;

	fetch(TOKEN_API_HOST + '/api/detail/token?id=' + tokenId)
		.then(function(resp){
			return resp.json();
			})
			.then(function(response) {

				if(response.error) {
					tokenDetailErr = response.response_code_desc || '';
					if(response.response_code === '635') {
						tokenDetailReason = invalidIdMsg;
						tokenStatus = -3; // To hide placeholders

					} else {
					tokenDetailReason = response.errmsg || '';
					}
				} else {

						qrImage = response.data.qr_image;
						qrString = response.data.qr_string;
						saleDesc = 	response.data.sale_desc	;
						products = response.data.display_items;
						current_amount = response.data.amount;
						old_amount = response.data.old_amount;
						expiry_date = response.data.expiry;
						customerName = response.data.customer_name;
						customerMobile = response.data.customer_id;
						tokenStatus = response.data.tx_status;
						paymentStatusDesc = response.data.txstatus_desc;

						if(tokenStatus == 2) {
							paymentStatusDesc = 'Unpaid';
						}

						if(response.data.brand) {
							brand_name = response.data.brand.name;
							brand_logo = response.data.brand.logo;
							brandCSEmail = response.data.brand.customer_support_email;
							brandCSLink = response.data.brand.customer_support_link;
						}

						// if(current_amount !== old_amount || true) { //DUMMY TODO

						if(old_amount && current_amount != old_amount) {
							priceChanged = true;
						}


				}

				QRapiCall = false;

			})
		.catch(function(){
			// QRapiCall = false;
			QRErr = 'Unable to load Token details. Please Try Again';
			QRapiCall = false;

		});

}



function captureLocation() {

	return new Promise(function(resolve, reject) {

		window.navigator.geolocation.getCurrentPosition(
			(position) => {

				const lat = position.coords.latitude;
				const long = position.coords.longitude;

				 resolve({lat, long});

				 // this.setState({lat: position.coords.latitude});
			 },
			(err) => {

				reject('fail');

				 // this.setState({errMsg: err.message});
			 }
		);

	});

}


function fetchNearbyMerchants(res) {

	nearbyMerchantsErr = '';
	nearbymerchant = [];
	showNearbyMerchantsSection = false;

	fetch(TOKEN_API_HOST + '/api/nearby/merchants?lat=' + res.lat + '&long=' + res.long)
		.then(function(resp){
				return resp.json();
			})
			.then(function(response) {


				// showNearbyMarchanrsBtn = false;

				if (response.data) {
					nearbymerchant = response.data;
				}

				if (response.data && response.data.length === 0) {
					nearbyMerchantsErr = 'No EkoStore found near your location. Please scan the QR Code using any payment App like Google Pay, BHIM, PhonePe, PayTm';
				}

				if(response.error) {
					nearbyMerchantsErr = response.errmsg || nearbyMerchantsErrMsg;
				}

				showNearbyMerchantsSection = true;
				nearbyMerchantsLoading = false;

			})
		.catch(function(err){

			nearbyMerchantsErr = nearbyMerchantsErrMsg;
			showNearbyMerchantsSection = true;
			nearbyMerchantsLoading = false;


		});

}

function showNearbyMerchants() {

	nearbyMerchantsLoading = true;
	waitingForLocation = true;


	captureLocation()
	.then(function(res) {
		fetchNearbyMerchants(res);
		waitingForLocation = false;

	})
	.catch(function(err) {
		nearbyMerchantsErr = 'Please allow location permission to see nearby EkoStores';
		showNearbyMerchantsSection = true;
		nearbyMerchantsLoading = false;
		waitingForLocation = false;
	}) ;
}


function fetchPaymentStatus() {

		_fetchingTokenStatus = true;

		fetch(TOKEN_API_HOST + '/api/payment/enquiry?id=' + tokenId)
			.then(function(resp){
				return resp.json();
			})
			.then(function(response) {

				_fetchingTokenStatus = false;

				showStatusToast = true;

				setTimeout(() => {
				showStatusToast = false;
				}, toastTimeout);

				paymentStatusDesc = response.payment_description || '';

				if(response.data) {
					tokenStatus = response.data.tx_status;
				}


			})
			.catch(function(){
				_fetchingTokenStatus = false;

				paymentStatusDesc = 'Kindly check your internet connection';
				showStatusToast = true;

				setTimeout(() => {
				showStatusToast = false;
				}, toastTimeout);

			});

}


function showProductDesc() {
	showProductDescSection = true;
	// showProductDescBtn = false;
}



function _formatToken(tokenId)
{ //TODO WHAT ID ID LENGTH > TOKEN_LENGTH

	if(tokenId.length > TOKEN_LENGTH) {
		return tokenId;
	}
	return tokenId ?
		(tokenId.substr(0, 4) + "-" + tokenId.substr(4, 4) + "-" + tokenId.substr(8, 4) + "-" + tokenId.substr(12, 4)) :
		"";
}

function _formatDate(strdt)
{
	var dt = new Date(strdt);

	if (dt && 'toLocaleString' in dt)
	{
		return dt.toLocaleString("en-IN", {
						// year:'numeric',
						month:'short',
						day:'numeric',
						hour:'numeric',
						minute:'numeric'
					}) || strdt;
	}
	else
	{
		return strdt;
	}
}

function _formatMobile(mob)
{
	mob = "" + mob;
	return mob ?
		("+91 " + mob.substr(0, 3) + " " + mob.substr(3, 3) + " " + mob.substr(6)) :
		""
}


function showPayOnMobile() {
		if( navigator.userAgent.match(/Android/i)
			|| navigator.userAgent.match(/webOS/i)
			|| navigator.userAgent.match(/iPhone/i)
			|| navigator.userAgent.match(/iPad/i)
			|| navigator.userAgent.match(/iPod/i)
			|| navigator.userAgent.match(/BlackBerry/i)
			|| navigator.userAgent.match(/Windows Phone/i)
			){
			isMobileDevice = true;
		}
}


function init() {

	if(isNaN(tokenId) || tokenId.length !== TOKEN_LENGTH ) {
		
		QRapiCall = false;
		tokenDetailReason = invalidIdMsg;
		tokenStatus = -3; // To hide placeholders
	} else {
		getTokenDetails();

	}

}

showPayOnMobile(); //TODO

init();

function openPaymentApps() { // For mobile
		window.open(qrString);
}


function openHowSection() {
	showHowSection = true;
	// smoothScrollTo('secamt');
	// document.querySelector("#secamt").scrollIntoView();
	document.querySelector("#secamt").scrollIntoView({ behavior: 'smooth'});	// block: 'end'
}

function scrollToNearbyStore() {
	showNearbyMerchants();
	// smoothScrollTo('secshops');
	document.querySelector("#secshops").scrollIntoView({ behavior: 'smooth'});
}


function _getBtnStatusCheckLabel(_fetchingTokenStatus)
{
	return _fetchingTokenStatus ? "Checking Status" : "Check Payment Status";
}

</script>


<style>

main {
	/* background-color: #215921; */
	color: #fff;
	padding: 15px;
	overflow: hidden;
}


#secqr {
	/* position:relative; */
	width:100%;
	padding:0.2em;
}

.qr-container {
	width: 100%;
	padding:0 1em;
	text-align: center;

	position:relative;
	/* width:100%; */
}


@media screen and (min-width: 500px) {
	.qr-container {
		width: 320px;
	}
}

	.amt {
		font-size:2.5em;
		font-weight:300;
		letter-spacing:3px;
		color:#EEE;
	}
	/* .big {
		font-size: 1.2em;
		font-weight:500;
	} */

	.oldprice {
		font-size: 1.2em;
		text-decoration: line-through;
	}

.boxMain {
		display: flex;
		flex-direction: column;
		/* justify-content: space-around; */
	}

.boxMain > * {
	display: flex;
	flex-direction: column;
	align-items: center;
}

header {
	font-weight:700;
	opacity:0.8;
}

label {
	font-size:0.75em;
	font-weight:700;
	margin-right:0.6em;
	/* color:var(--lighter-2-text-color); */
	opacity:0.7;
	letter-spacing:2px;
	text-transform:uppercase;
}

label[highlight] {
	opacity:0.9;
}

section {
	width:100%;
	padding:1em 0;
	display:flex;
	flex-direction:row;
	justify-content:center;
	align-items:center;
	/* flex-grow:0; */
}

section[dual] {
	justify-content: space-between;
}

section[divide] {
	border-bottom:1px solid rgba(255,255,255,0.2);	/* #275b52;*/
}

section[divideup] {
	border-top:1px solid rgba(255,255,255,0.2);
}

section > .td {
	display:flex;
	flex-direction:column;
	justify-content:center;
	align-items:center;
	min-width:5em;
}

section[dual] > .td:first-child {
	align-items:flex-start;
	text-align:left;
	margin-right:1em;
}

section[dual] > .td:last-child {
	align-items:flex-end;
	text-align:right;
	margin-left:1em;
}


section > .td > label {
	margin:0;
}
section > .td > .val {
	margin-top:0.3em;
	/* font-size:1.1em; */

	max-width:100%;
	min-width:5em;
	white-space:nowrap;
	overflow:hidden;
	text-overflow:ellipsis;
}


#secid {
	font-family:monospace;
	letter-spacing:6px;
	/* font-size:1.1em; */
	font-weight:700;
	opacity:0.65;
	text-align:center;
	padding:0.1em 0;
}

#secamt {
	padding:0.2em 0;
	display: flex;
	flex-direction: row;
	justify-content:space-evenly;
}

#secexp {
	font-size:0.85em;
}

#sechow {
	max-width: 100%;
    background-color: #01402a;
    padding: 12px;
	font-size: 16px;
    line-height: 28px;
}

#secshops {
	flex-direction: column;
}

#secshops .spinner-box{
	max-width: 100px;
}

.shoplist {
	max-width:100%;
	background-color: #01402a;
	/* background-color: #26574e; */
	padding: 12px;
	margin-top:0.5em;
}


#secsupport {
	/* border-top: 1px solid #809d89; */
	border-color:#809d89;
	margin-top: 3em;
}



main[status="11"] > #secshops,
main[status="10"] > #secshops,
main[status="-3"] > #secshops,
main[status="-3"] #detailbox,
main[status="0"] > #secshops {
	display: none;
}


/* status */
/* -3 stop at fronntend error - hide placeholder */
/* 2 - unpaid */
/* -1 not received data from API yet or error from backend API */

main:not([status="2"]):not([status="-1"]):not([status="-3"]) .qr-image-box {
	filter:blur(3px);
}



.strip {
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 100%;
	height: 100px;
	/* background-color: #19402a; */
	background: rgba(0,0,0,0.95);
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1.6em;
	font-weight: 400;
	text-align: center;
	border-radius: 6px;
	/* min-width:10em; */

	/* background: rgba(0,0,0,0.9);
    color: #dd0074;
    font-weight: 400; */

	box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14),
			0 3px 14px 2px rgba(0, 0, 0, 0.12),
			0 5px 5px -3px rgba(0, 0, 0, 0.4);
}

main[status="1"] .strip,
main[status="10"] .strip,
main[status="11"] .strip {
	color:#dd0074;
}

main[status="0"] .strip,
main[status="4"] .strip {
	color:#008b00;
}

main[status="3"] .strip {
	color:#ff8d00;
}


/* ---------- LOAD PLACEHOLDERS ---------- */


/* .boxMain[busy="1"] label {
	color:transparent;
	display:none;
} */
/* .boxMain[busy="1"] label::after, */
.boxMain[busy="1"] .val::after {
	content:"M";
	width:10em;
	height:1.2em;
	background:grey;
	color:transparent;
	display:inline-block;
	border-radius:2px;
	animation: pulsate 2s linear infinite;
}

@keyframes pulsate {
		0%   { opacity: 0.9; }
		50% { opacity:0.3; }
		100%   { opacity: 0.9; }
	}

.boxMain[busy="1"] label::after {
	width:10em;
}



/* ======================== MEDIA QUERIES ====================== */


@media screen and (min-width: 1000px) {
	main {
		margin: auto 8%;
	}

	section {
		padding:1em 0.5em;
	}
}


@media all and (orientation:landscape) and (min-width:600px) {

	main {
		padding:5px 10px;
	}

	.boxMain {
		flex-direction: row;
		justify-content: space-around;
		margin-bottom:3em;
	}

	.boxMain > * {
		flex-grow: 1;
		max-width:50%;
	}

	.boxMain section {
		max-width:600px;
		padding:1em 0.2em;
	}

	#secid {
		order:2;
	}

}


@media all and (orientation:landscape)  and (min-width: 1000px) {

	main {
		padding:15px;
	}

	#secqr {
		padding:1em 0.2em;
	}

}




</style>


<main status="{tokenStatus}" > 		<!-- status="{token.data.status}" -->

	<div class="boxMain" busy={QRapiCall ? "1" : "0"}>

		<div class="boxQR">

			<!------------------------  QR Code ----------------------->

			<section id="secid">{_formatToken(tokenId)}</section>


			<section id="secqr">

				<div class="qr-container">

					{#if QRapiCall}

						<Spinner />

					{/if}

					<div class="qr-image-box">
						<Qrimage
						qrImage = {qrImage}
						qrString = {qrString}
						errmsg = {tokenDetailErr}
						errreason = {tokenDetailReason} />
					</div>

					<div class="err">{QRErr}</div>

					{#if ",0,1,3,4,10,11,".indexOf(","+tokenStatus+",") >= 0 }

						<div class="strip">

							<!-- {#if ",0,4,".indexOf(","+tokenStatus+",") >= 0 }
								<svg class="ico" viewBox="0 0 24 24" aria-hidden="true">
									<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
								</svg>
							{/if} -->

							{paymentStatusDesc}

						</div>

					{/if}

				</div>

			</section>

		</div>


		<div class="boxDetails" id ="detailbox">

			<!------------------------ Token amount ----------------------->

			<section id="secamt">

				{#if tokenStatus === 2}
					<label>Pay</label>
				{/if}

				<span class="amt">₹{current_amount}</span>

				{#if priceChanged}
					<span class="oldprice">
						(₹{old_amount})
					</span>
				{/if}

				{#if tokenStatus === 2}
				<button id="howbtn" pill raised primary on:click={openHowSection}>How?</button>
				{/if}


				<!-- {#if tokenStatus === 2}
					<span class="small-text">
						<label>Expires</label>{expiry_date}
					</span>
				{/if} -->

			</section>

			<!------------------------ Token expiry ----------------------->

			<section id="secexp">

				{#if tokenStatus === 2}
					<label highlight>Payment Due <span>Before</span></label>
					<span>{_formatDate(expiry_date)}</span>
				{/if}

			</section>

			<!-- ------------------------- How to Pay ---------------------- -->

			{#if showHowSection}

				<section id="sechow" transition:slide="{{ duration: 300 }}">		<!-- transition:fly="{{ y: 100, duration: 1000 }}" -->

					<div class = "td">

						<header>How to Pay?</header>

						<ul>
							<li>Visit any nearby EkoStore to pay in cash <button pill raised primary on:click={scrollToNearbyStore}>Locate</button> </li>
							<li>Or, Scan the QR Code using any payment App like Google Pay, BHIM, PhonePe, PayTm</li>

							{#if isMobileDevice && qrString }
								<li>Or, <button pill raised primary on:click={openPaymentApps}>Pay</button> using your phone's Payment App</li>
							{/if}
						</ul>

					</div>

				</section>
			{/if}





			<!-- ---------------------- RECHECK STATUS ---------------- -->

			<section>
				{#if tokenStatus === 2 || tokenStatus === 3}
					<button pill raised disabled={_fetchingTokenStatus} on:click={fetchPaymentStatus}>
						<span class="spinner" pill hidden={!_fetchingTokenStatus}></span>
						{_getBtnStatusCheckLabel(_fetchingTokenStatus)}
					</button>
					<!-- <span class = "stat"> {paymentStatusDesc} </span> -->

				{/if}
			</section>


			<!------------------------ Token Id ----------------------->

			<!-- <section>
				<Propval label = "Token Id" labelval = {tokenId} />
			</section> -->

			<!-- -------------------- BRAND/PRODUCT LIST ----------------------- -->

			<section dual divide divideup>
				<div class="td">
					<label>To</label>
					<span class="val">{brand_name}</span>
				</div>
				<div class="td">
					<label>For</label>
					<span class="val">{saleDesc}</span>
				</div>
			</section>

			<!-- --------- CUSTOMER name, mobile, brand, product desc------------ -->

			<section dual divide>
				<div class="td">
					<label>Name</label>
					<span class="val">{customerName}</span>
				</div>

				<div class="td">
					<label>Mobile</label>
					<span class="val">{_formatMobile(customerMobile)}</span>
				</div>
			</section>


		</div>

	</div>



	<!-- ------------------------- MEARCHANT MAP ---------------------- -->
	<section id="secshops">

		<button raised on:click={showNearbyMerchants}>Show Nearby EkoStores</button>

		{#if nearbyMerchantsLoading}
			<div class="spinner-box">
				<Spinner/>
			</div>
		{/if}

		{#if waitingForLocation}
			<div class="loc-wait">
				<span>
					Please allow location permission & turn on GPS Services to see nearby EkoStores
				</span>
			</div>
		{/if}


		{#if showNearbyMerchantsSection && !nearbyMerchantsLoading}

			<!-- NOTE DO NOT ADD TRANSITION IS HINDERS RE RENDERING OF COMPONENTS -->
			<!-- <div class="shoplist" transition:slide="{{ duration: 300 }}"> -->

			<div class="shoplist">
				<NearbyMerchants
					nearbymerchant = {nearbymerchant}
					isMobileDevice = {isMobileDevice}
					nearbyMerchantsErr = {nearbyMerchantsErr} />
			</div>
		{/if}

	</section>



	<!-- ---------------------------- SUPPORT -------------------------- -->
	<section id="secsupport" divideup>
		<ContactSupport
			brandCSEmail = {brandCSEmail}
			brandName = {brand_name}
			brandCSLink = {brandCSLink}
			tokenId = {tokenId}
		/>
	</section>

	{#if showStatusToast && paymentStatusDesc}

		<section id = "secstatustoast">
			<Toast data = "{paymentStatusDesc}" icon = "" />
		</section>

	{/if}

</main>
